export default __webpack_public_path__ + "static/quadra.76477db0414db7f57c7b6394f9d27b1c.png";